import { motion } from "motion/react";
import { useSectionParallax } from "../../../hooks/useSectionParallax";

const SURFACES = [
  {
    label: "Flow · No Code",
    title: "For people who don't write code.",
    assistant: "Mona",
    accentCls: "text-[#0284C7] dark:text-[#38BDF8]",
    borderCls: "border-t-[#0284C7] dark:border-t-[#38BDF8]",
    lines: ["Visual canvas of connected blocks", "Declarative clean and transform steps", "Statistics and models built in", "Mona builds and fixes flows; you approve"],
  },
  {
    label: "Notebook · Code",
    title: "For people who do.",
    assistant: "Merlin",
    accentCls: "text-[#1E4FD8] dark:text-[#4A90D9]",
    borderCls: "border-t-[#1E4FD8] dark:border-t-[#4A90D9]",
    lines: ["Python or R on a dedicated cloud kernel", "Tabbed pages with results beside the code", "Popular libraries pre-installed; up to 61 GB RAM", "Add any PyPI or CRAN package from the Packages tab", "Merlin writes and runs pages; you approve, or let it run"],
  },
];

export function FlowVsNotebook() {
  const { ref, bgY, fgY } = useSectionParallax();
  return (
    <div ref={ref}>
      <motion.div style={{ y: fgY }}>
        <h3 className="text-3xl font-normal tracking-[-0.02em] text-[#0A0A0F] dark:text-white text-center max-w-2xl mx-auto mb-4">
          Two ways to work. One workspace.
        </h3>
        <p className="text-base leading-[1.7] text-[#5C5C66] dark:text-[#9A9A9A] text-center max-w-xl mx-auto mb-12">
          Flow and Notebook live side by side in the same projects and workspaces.
        </p>
      </motion.div>
      <motion.div className="grid md:grid-cols-2 gap-6 max-w-5xl mx-auto" style={{ y: bgY }}>
        {SURFACES.map(({ label, title, assistant, accentCls, borderCls, lines }) => (
          <div key={label} className={`rounded-2xl border border-[#0A0A0F]/10 dark:border-white/10 border-t-2 ${borderCls} bg-white dark:bg-[#0D0D10] p-8`}>
            <p className={`text-xs font-semibold uppercase tracking-[0.2em] mb-3 ${accentCls}`}>{label}</p>
            <p className="text-xl font-normal tracking-[-0.01em] text-[#0A0A0F] dark:text-white mb-6">{title}</p>
            <ul className="space-y-2 mb-6">
              {lines.map((l) => (
                <li key={l} className="text-sm text-[#5C5C66] dark:text-[#9A9A9A]">{l}</li>
              ))}
            </ul>
            <p className={`text-xs font-semibold uppercase tracking-widest ${accentCls}`}>AI assistant · {assistant}</p>
          </div>
        ))}
      </motion.div>
    </div>
  );
}
